import React from 'react'
import MaterialTable from '@material-table/core'
import { Colors } from '@auteco/theme'
import { format } from 'date-fns'

const FinalValuesTable = ({ consolidadoMaterialInfo }) => {
  const formatUnixToMonthYear = (unix) => {
    try {
      return format(new Date((unix + 86000) * 1000), 'MMM yyyy')
    } catch (e) {
      return ''
    }
  }

  const data = consolidadoMaterialInfo.map((item, index) => ({
    ajuste_demanda: item.ajuste_demanda
      ? parseFloat(parseFloat(item.ajuste_demanda).toFixed(3)).toString() : '0',
    baseline: item.baseline ? parseFloat(parseFloat(item.baseline).toFixed(3)).toString() : '0',
    category: item.category || '0',
    gerente: item.gerente || '0',
    index: index + 1,
    mes:
      item.mes_unix && item.mes_unix > 0
        ? formatUnixToMonthYear(item.mes_unix)
        : '',
    final: item.final ? parseFloat(parseFloat(item.final).toFixed(3)).toString() : '0',
    presupuesto_unidades: item.presupuesto_unidades || '0',
    masivo: item.masivo || '0',
  }))

  const transformData = (data, rows) => {
    const columns = [
      { title: ' ', field: 'title' },
      ...data.map((item) => ({ title: item.mes, field: item.mes })),
    ]

    const transformedData = rows.map((row) => {
      const rowData = { title: row.title }
      data.forEach((item) => {
        rowData[item.mes] = item[row.field] || ''
      })
      return rowData
    })

    return { columns, transformedData }
  }

  const secondTableData = data.filter(
    (item) => item.index >= 13 && item.index <= 25,
  )
  const rowsForSecondTable = [
    { title: 'Ajuste demanda', field: 'ajuste_demanda' },
    { title: 'BASELINE', field: 'baseline' },
    { title: 'CATEGORY', field: 'category' },
    { title: 'GERENTE', field: 'gerente' },
    { title: 'FINAL', field: 'final' },
    { title: 'PRESUPUESTO', field: 'presupuesto_unidades' },
    { title: 'MASIVO', field: 'masivo' },
  ]

  const secondTable = transformData(secondTableData, rowsForSecondTable)

  return (
    <>
      <MaterialTable
        title="Baseline"
        data={secondTable.transformedData}
        columns={secondTable.columns}
        options={{
          toolbar: false,
          pageSize: 6,
          pageSizeOptions: [],
          paginationType: 'stepped',
          headerStyle: {
            backgroundColor: Colors.BLUE,
            color: '#f1f1f1',
            fontSize: '14px',
            fontWeight: 700,
          },
          rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
            padding: '5px',
            fontSize: '12px',
          }),
        }}
      />
    </>
  )
}

export { FinalValuesTable }
